import React from "react";
import Button from "@source/components/UI/buttons/button/button";
import ConfirmModal from "@source/components/confirmModal/confirmModal";
import SelectInput from "@source/components/UI/inputs/selectInput/selectInput";
import {ConsentCategory, ConsentCategorySource} from "@source/api/models/consentModels";
import {IncrementalConsentListResult} from "@source/hooks/useIncrementalConsentList";
import {ConsentAutoLoad, ConsentRequestState} from "@source/components/consentDocuments";
import {rolesText} from "./consentStepsShared";
import styles from "./consentSteps.module.scss";

export const CategoryStep = ({categories, categoryId, selected, unavailableName, categoryUnavailable, disabled, error, onChange, onCancel, onDelete, deleting, onContinue}: {
  categories: IncrementalConsentListResult<ConsentCategory>;
  categoryId: string;
  selected: ConsentCategory | null;
  unavailableName?: string;
  categoryUnavailable: boolean;
  disabled: boolean;
  error: string;
  onChange: (categoryId: string) => void;
  onCancel: () => void;
  onDelete?: () => void;
  deleting?: boolean;
  onContinue: () => void;
}) => <section className={styles.categoryStep}>
  {categoryUnavailable && unavailableName ? <div className={styles.unavailable} role="alert"><strong>{unavailableName}</strong> is no longer active. Select another Form Category before continuing.</div> : null}
  {categories.isLoading && !categories.items.length ? <ConsentRequestState variant="loading" title="Loading active Form Categories"/> : null}
  {categories.error && !categories.items.length ? <ConsentRequestState variant="error" title="Unable to load Form Categories" description={categories.error} onRetry={categories.retry}/> : null}
  {categories.items.length ? <>
    <SelectInput
      id="consent-category"
      className={styles.formControl}
      label="Form Category"
      required
      value={categoryId}
      placeholder="Select a form category"
      items={categories.items.map((category) => ({id: category._id, value: category._id, title: category.name}))}
      disabled={disabled}
      handleChange={(event) => onChange(event.target.value)}
    />
    {selected ? <p className={styles.categorySupport}>{selected.source === ConsentCategorySource.TEMPLATE ? "Template source" : "PDF source"} · Required roles: {selected.requiredSignerRoles.map((role) => role.replace(/_/g, " ")).join(", ")} · {rolesText(selected)}</p> : null}
  </> : null}
  {!categories.isLoading && !categories.error && !categories.items.length ? <ConsentRequestState variant="empty" title="No active Form Categories" description="Ask an administrator to configure an active Form Category."/> : null}
  {categories.error && categories.items.length ? <div className={styles.categoryRetry} role="alert"><span>More Form Categories could not be loaded. {categories.error}</span><Button size="small" variant="outlined" onClick={categories.retry}>Retry</Button></div> : null}
  <ConsentAutoLoad hasMore={categories.hasMore} isLoading={categories.isLoading} error={categories.error} onLoadMore={categories.loadMore}/>
  {error ? <p className={styles.error} role="alert">{error}</p> : null}
  <div className={styles.actions}>
    <Button size="small" variant="outlined" className={styles.leftBtn} onClick={onCancel} disabled={disabled}>Cancel</Button>
    {onDelete ? <ConfirmModal title="Are you sure you want to delete the form draft?" confirmCb={onDelete} confirmLoading={deleting}>
      <Button size="small" variant="outlined" className={styles.leftBtn} disabled={disabled}>Delete</Button>
    </ConfirmModal> : null}
    <Button size="small" className={styles.leftBtn} onClick={onContinue} disabled={disabled || !selected || categoryUnavailable}>Continue</Button>
  </div>
</section>;
